module.exports = __webpack_public_path__ + "left.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/left.svg?color1=%23333333&color2=
// module id = 544
// module chunks = 67